<template>
	<div>
		<el-row :gutter="20">
			<el-col align="right">
				<div class="userInfo">
					<div class="tip userInfoLabel">
						<b>Usuario en sesión</b>
						<div style="border: 1px solid #fff;
								    margin-left: -13px;
								    margin-right: -13px;
								    margin-bottom: 10px;"></div>
						Usuario: {{ userInfo ? userInfo.full_name : '' }}
						<br/>
						Perfil: {{ userInfo ? userInfo.profile.name : ''}}
						<br/>
						Representación: {{ userInfo && userInfo.office ? userInfo.office.type.name : ''}} en {{ userInfo &&
						userInfo.office ? userInfo.office.location : ''}}

					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import {mapState, mapGetters, mapActions, mapMutations} from "vuex";

	export default {
		computed: {
			...mapGetters(["userInfo"]),
		}
	}
</script>

<style>
.userInfo {
	padding: 0px;
	position: relative;
	float: right;
}

.userInfoLabel {
	background-color: #4a90e2 !important;
	border-left: 5px #4a90e2 !important;
	color: #fff !important;
	font-size: 12px;
	/* font-weight: bold; */
	text-align: left;
	margin: 10px 0 !important;
}
</style>